import React, { lazy, Suspense, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setTemplateId,
  setOpenCreateDocumentModal,
  setOpenRenameFileModal,
  setClickedDocOrFolderIdInStore,
} from '../../features/template/template.js';
import useDocumentCreation from '../../hooks/useDocumentCreation.js';

const RenameModal = lazy(() => import('../Modal/RenameModal.jsx'));
const EditorPreviewModal = lazy(() => import('@components/Modal/EditorPreviewModal.jsx'));

const CreateDocuments = () => {
  const dispatch = useDispatch();
  const { onFileNameHandler } = useDocumentCreation();
  const openCreateDocumentModal = useSelector((state) => state.template?.openCreateDocumentModal);
  const openRenameFileModal = useSelector((state) => state.template?.openRenameFileModal);
  const clickedDocOrFolderId = useSelector((state) => state.template?.clickedDocOrFolderId);

  const closeCreateDocumentModal = useCallback(() => {
    dispatch(setOpenCreateDocumentModal(false));
  }, [dispatch]);

  const templateSelectedHandler = useCallback(
    (id) => {
      // dispatch(setTemplateId(id));
      dispatch(setOpenCreateDocumentModal(false));
      setTimeout(() => onFileNameHandler(id, 'New Doc', clickedDocOrFolderId), 0);

      // dispatch(setOpenRenameFileModal(true));
    },
    [dispatch, clickedDocOrFolderId, onFileNameHandler]
  );

  const renderModals = useMemo(
    () => (
      <>
        {openCreateDocumentModal && (
          <Suspense fallback={null}>
            <EditorPreviewModal
              open={openCreateDocumentModal}
              onTemplateSelect={templateSelectedHandler}
              onClose={closeCreateDocumentModal}
            />
          </Suspense>
        )}
        {openRenameFileModal && (
          <Suspense fallback={null}>
            <RenameModal
              open={openRenameFileModal}
              onCancel={() => {
                dispatch(setOpenRenameFileModal(false));
                dispatch(setTemplateId(null));
              }}
              onSubmit={(templateId, name) => onFileNameHandler(templateId, name, clickedDocOrFolderId)}
            />
          </Suspense>
        )}
      </>
    ),
    [
      openCreateDocumentModal,
      openRenameFileModal,
      templateSelectedHandler,
      closeCreateDocumentModal,
      onFileNameHandler,
      clickedDocOrFolderId,
    ]
  );

  return renderModals;
};

export default React.memo(CreateDocuments);
